var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: "批量拉黑IP",
        visible: _vm.visible,
        width: "600px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": (val) => _vm.$emit("update:visible", val),
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c("div", { staticClass: "ip-list-section" }, [
            _c("div", { staticClass: "section-title" }, [_vm._v("拉黑IP")]),
            _vm.ipList.length > 0
              ? _c(
                  "div",
                  { staticClass: "ip-list" },
                  _vm._l(_vm.ipList, function (ip, index) {
                    return _c(
                      "el-tag",
                      {
                        key: index,
                        staticStyle: {
                          "margin-right": "5px",
                          "margin-bottom": "5px",
                        },
                        attrs: {
                          closable: "",
                          "disable-transitions": true,
                          type: "danger",
                        },
                        on: {
                          close: function ($event) {
                            return _vm.removeIp(index)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(ip) + " ")]
                    )
                  }),
                  1
                )
              : _c("div", { staticClass: "empty-tip" }, [_vm._v("暂无IP数据")]),
          ]),
          _c(
            "el-form",
            {
              ref: "blackIpFormRef",
              staticStyle: { "margin-top": "20px" },
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "限制方式", prop: "limit_type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        multiple: "",
                        placeholder: "请选择",
                        clearable: "",
                      },
                      model: {
                        value: _vm.formData.limit_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "limit_type", $$v)
                        },
                        expression: "formData.limit_type",
                      },
                    },
                    _vm._l(_vm.limitTypeOptions, function (opt) {
                      return _c("el-option", {
                        key: opt.value,
                        attrs: { label: opt.label, value: opt.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入拉黑备注（最多100字）",
                      maxlength: 100,
                      "show-word-limit": "",
                      rows: "3",
                    },
                    model: {
                      value: _vm.formData.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "remark", $$v)
                      },
                      expression: "formData.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "同时拉黑IP登录过的账号" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-text": "是",
                      "inactive-text": "否",
                      "active-value": true,
                      "inactive-value": false,
                    },
                    model: {
                      value: _vm.formData.isDisableAccounts,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "isDisableAccounts", $$v)
                      },
                      expression: "formData.isDisableAccounts",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }